import { useContext } from "react";
import { SceneContext } from "../context/SceneContext";

export const useScene = () => {
    const context = useContext(SceneContext);
    if (!context) {
        throw new Error("useScene must be used inside SceneProvider");
    }
    return context;
};
